import omit from 'lodash/omit';

import Grid from '@mui/material/Grid';

import ReportTable from './ReportTable';
import ShowReportFilters from './ShowReportFilters';

const WeeklyProviderActuationSummaryReport = ({
  report,
}) => {
  const tableData = report?.report_data?.data?.[0];
  if (!report) return <></>;
  return (
    <>
      <ShowReportFilters
        report={report}
      />
      <ReportTable
        title={tableData?.name || ''}
        columns={tableData?.columns || []} 
        rows={tableData?.rows || []}
      />
    </>
  );
};

export default WeeklyProviderActuationSummaryReport;